import { Row, Skeleton, Spin } from 'antd';
import React, { Suspense, useState } from 'react';
import { useSelector } from 'react-redux';
// import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useFragment, useLazyLoadQuery, useMutation } from 'react-relay';

import { AttachmentConnectionFragment$key } from '../../graphql/__generated__/AttachmentConnectionFragment.graphql';
import { AttachmentFragment$key } from '../../graphql/__generated__/AttachmentFragment.graphql';
import { AttachmentListFragment$key } from '../../graphql/__generated__/AttachmentListFragment.graphql';
import { AttachmentsQuery as AttachmentsQueryType } from '../../graphql/__generated__/AttachmentsQuery.graphql';
import { AttachmentsQuery } from '../../graphql/AttachmentsQuery';
import { AttachmentConnectionFragment } from '../../graphql/fragments/AttachmentConnectionFragment';
import { AttachmentListFragment } from '../../graphql/fragments/AttachmentListFragment';
import UpdateBulkAttachmentOrderMutation from '../../graphql/mutations/UpdateBulkAttachmentOrderMutation';
import useCommitAttachment from '../../hooks/useCommitAttachment';
import { RootState } from '../../store';
import AttachmentCard from './AttachmentCard';
import AttachmentUploadButton from './AttachmentUploadButton';

export interface IAttachment {
    model_id: string;
    model_type: string;
    isAccess: { create?: boolean; delete?: boolean; view?: boolean };
    fetchKey?: number;
}

export const AttachmentsComponent: React.FC<IAttachment> = ({ model_id, model_type, isAccess }) => {
    const queryData = useLazyLoadQuery<AttachmentsQueryType>(AttachmentsQuery, {
        model_id: model_id,
        model_type: model_type,
    });
    const fragmentData = useFragment<AttachmentListFragment$key>(AttachmentListFragment, queryData);
    const conData = useFragment<AttachmentConnectionFragment$key>(
        AttachmentConnectionFragment,
        fragmentData.attachments,
    );
    const attachments =
        [...(conData?.edges || [])].sort((doc1: any, doc2: any) => {
            return doc1?.node?.order - doc2?.node?.order;
        }) || [];
    const spinner = useSelector<RootState, boolean>((state) => state.spinner.spinner);
    const connectionId = (fragmentData.attachments as any)?.__id;

    const [isDragging, setIsDragging] = useState(false);
    const [commitOrder] = useMutation(UpdateBulkAttachmentOrderMutation);
    const { getCommitBulkAttachment } = useCommitAttachment();

    const _onDragStart = () => {
        setIsDragging(true);
    };

    const _onDragEnd = (result: any) => {
        setIsDragging(false);
        if (!result.destination) {
            return;
        }

        const items = Array.from(attachments).sort((doc1: any, doc2: any) => {
            return doc1?.node?.order - doc2?.node?.order;
        });
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        const new_order = items.map((item) => {
            const node = item?.node as any;
            return node.__id;
        });
        commitOrder(
            getCommitBulkAttachment(
                {
                    model_type,
                    model_id,
                    new_order,
                },
                connectionId,
            ),
        );
    };

    return (
        <Spin spinning={spinner}>
            {/* <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}> */}
            {/* <Droppable droppableId="attachments" direction="horizontal"> */}
            {/* {(provided: any) => ( */}
            <Row
                // {...provided.droppableProps}
                // ref={provided.innerRef}
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    margin: '-8px',
                }}
            >
                {[...attachments]
                    .sort((doc1: any, doc2: any) => {
                        return doc1?.node?.order - doc2?.node?.order;
                    })
                    .map((item, index) => (
                        <AttachmentCard
                            key={item?.cursor}
                            attachment={item?.node as AttachmentFragment$key}
                            index={index}
                            connectionId={connectionId}
                            model_id={model_id}
                            model_type={model_type}
                            accessToDelete={!!isAccess?.delete}
                        />
                    ))}
                {/* {provided.placeholder} */}
                {!isDragging && (isAccess.create || isAccess.view) && (
                    <AttachmentUploadButton model_id={model_id} model_type={model_type} connectionId={connectionId} />
                )}
            </Row>
            {/* )} */}
            {/* </Droppable> */}
            {/* </DragDropContext> */}
        </Spin>
    );
};

export default function Attachments(props: IAttachment) {
    return (
        <Suspense fallback={<Skeleton active />}>
            <AttachmentsComponent {...props} />
        </Suspense>
    );
}
